const IconQuality = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 4L38.5 20H56L42.5 30L48 46L32 36L16 46L21.5 30L8 20H25.5L32 4Z" fill="currentColor" />
  </svg>
);

const IconTruck = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="18" width="38" height="26" rx="2" fill="currentColor" />
    <path d="M40 26H54L60 36V44H40V26Z" fill="currentColor" />
    <circle cx="14" cy="48" r="6" fill="var(--dark)" stroke="currentColor" strokeWidth="3" />
    <circle cx="50" cy="48" r="6" fill="var(--dark)" stroke="currentColor" strokeWidth="3" />
  </svg>
);

const IconStock = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="42" width="56" height="14" rx="2" fill="currentColor" />
    <rect x="4" y="25" width="56" height="12" rx="2" fill="currentColor" opacity="0.7" />
    <rect x="4" y="8" width="56" height="12" rx="2" fill="currentColor" opacity="0.4" />
  </svg>
);

const IconPrice = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="5" fill="none" />
    <text x="32" y="42" textAnchor="middle" fill="currentColor" fontSize="28" fontWeight="bold" fontFamily="sans-serif">$</text>
  </svg>
);

const cards = [
  {
    Icon: IconQuality,
    title: 'Calidad a tu medida',
    text: 'Manejamos distintos tipos de calidad según los requerimientos de cada cliente y proyecto, desde herrería ligera hasta construcción estructural.',
  },
  {
    Icon: IconTruck,
    title: 'Corte, Doblado y Entregas',
    text: 'Habilitamos el material según tus especificaciones — corte y doblado incluidos — y lo llevamos hasta tu obra o taller.',
  },
  {
    Icon: IconStock,
    title: 'Amplio inventario',
    text: 'Contamos con inventario disponible en múltiples medidas y calibres para entrega inmediata.',
  },
  {
    Icon: IconPrice,
    title: 'Precios competitivos',
    text: 'Precios justos y accesibles. Consúltanos sobre precios por volumen y proyectos especiales.',
  },
];

export default function WhyUs() {
  return (
    <section className="whyus">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Por qué elegirnos</p>
          <h2 className="section-title light">Nuestras Ventajas</h2>
          <div className="section-divider" />
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        <div className="whyus-grid">
          {cards.map(({ Icon, title, text }) => (
            <div key={title} className="whyus-card">
              <div className="whyus-icon">
                <Icon />
              </div>
              <h3 className="whyus-title">{title}</h3>
              <p className="whyus-text">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
